module.exports = __webpack_public_path__ + "img/icon-fabu.1f2cac6.png";